class ControllerDeviceService {
}
export const controllerDeviceService = new ControllerDeviceService();
